// Import independent property types
import './code';
import './repeater';
import './text';
import './textarea';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { isDefined } from '@automator/utilities';

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
const strings = UncannyAutomatorBackend.logs.components.logSidebarProperty.i18n;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-sidebar-property' )
export class AutomatorLogSidebarProperty extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String, attribute: false } ) accessor type;

	@property( { type: String, attribute: false } ) accessor label;

	@property( { type: String, attribute: false } ) accessor value;

	@property( { type: Object, attribute: false } ) accessor attributes = {};

	// eslint-disable-next-line require-jsdoc
	render() {
		if ( this.type === 'repeater' ) {
			return html`
				<uap-log-sidebar-property-repeater
					.label=${ this.label }
					.value=${ this.value }
					.attributes=${ this.attributes }
				></uap-log-sidebar-property-repeater>
			`;
		}

		if ( this.type === 'textarea' ) {
			return html`
				<uap-log-sidebar-property-textarea
					.label=${ this.label }
					.value=${ this.value }
					.attributes=${ this.attributes }
				></uap-log-sidebar-property-textarea>
			`;
		}

		if ( this.type === 'code' ) {
			return html`
				<uap-log-sidebar-property-code
					.label=${ this.label }
					.value=${ this.value }
					.attributes=${ this.attributes }
				></uap-log-sidebar-property-code>
			`;
		}

		return html`
			<uap-log-sidebar-property-text
				.label=${ this.label }
				.value=${ this.value }
				.attributes=${ this.attributes }
			></uap-log-sidebar-property-text>
		`;
	}
}